import { Phone, Mail, Trash2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

const STATUS_LABELS = { nouveau: "Nouveau", contacte: "Contacté", devis: "Devis émis" };

export default function MessagesList({ messages, refresh }) {
  const setStatus = async (id, status) => {
    try {
      await api.patch(`/messages/${id}`, { status });
      refresh();
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };

  const remove = async (id) => {
    try {
      await api.delete(`/messages/${id}`);
      toast.success("Demande supprimée.");
      refresh();
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };

  if (!messages.length) {
    return (
      <div className="border border-black/10 rounded-lg bg-white p-10 text-center" data-testid="messages-empty">
        <p className="text-base text-zinc-500">Aucune demande de devis pour le moment.</p>
      </div>
    );
  }

  return (
    <div className="space-y-4" data-testid="admin-messages-list">
      {messages.map((m) => (
        <div key={m.id} className="border border-black/10 rounded-lg bg-white p-5" data-testid="message-card">
          <div className="flex flex-wrap items-start justify-between gap-3">
            <div>
              <p className="font-display font-bold text-lg text-zinc-900" data-testid="message-name">{m.nom}</p>
              <div className="mt-1 flex flex-wrap gap-x-4 gap-y-1 text-sm text-zinc-600">
                <a href={`tel:${m.telephone}`} className="flex items-center gap-1.5 hover:text-citek-greenDark" data-testid="message-phone"><Phone size={13} />{m.telephone || "—"}</a>
                <a href={`mailto:${m.email}`} className="flex items-center gap-1.5 hover:text-citek-greenDark" data-testid="message-email"><Mail size={13} />{m.email}</a>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <select
                value={m.status || "nouveau"}
                onChange={(e) => setStatus(m.id, e.target.value)}
                data-testid="message-status-select"
                className="admin-input !w-auto !py-2 text-sm"
              >
                {Object.entries(STATUS_LABELS).map(([v, l]) => (
                  <option key={v} value={v}>{l}</option>
                ))}
              </select>
              <button onClick={() => remove(m.id)} data-testid="message-delete-button" aria-label="Supprimer" className="h-9 w-9 flex items-center justify-center border border-black/10 rounded-md text-zinc-500 hover:text-red-500 hover:border-red-400/40 transition-colors">
                <Trash2 size={15} />
              </button>
            </div>
          </div>
          <div className="mt-3 flex flex-wrap gap-2">
            {m.type_travaux && <span className="font-tech text-[11px] uppercase tracking-[0.16em] text-citek-greenDark border border-citek-greenDark/30 bg-citek-green/5 rounded px-2.5 py-1">{m.type_travaux}</span>}
            {m.budget && <span className="font-tech text-[11px] uppercase tracking-[0.16em] text-zinc-500 border border-black/10 rounded px-2.5 py-1">Budget : {m.budget} €</span>}
            <span className="font-tech text-[11px] uppercase tracking-[0.16em] text-zinc-400 border border-black/10 rounded px-2.5 py-1">{m.created_at ? new Date(m.created_at).toLocaleString("fr-FR") : ""}</span>
          </div>
          {m.message && <p className="mt-3 text-base leading-relaxed text-zinc-600" data-testid="message-body">{m.message}</p>}
        </div>
      ))}
    </div>
  );
}
